import { useMemo, useState, type ReactNode } from 'react';

import { MainCtaContext, type MainCtaConfig } from './mainCta';

export function MainCtaProvider({ children }: { children: ReactNode }) {
  const [cta, setCta] = useState<MainCtaConfig | null>(null);
  const value = useMemo(() => ({ cta, setCta }), [cta]);
  return <MainCtaContext.Provider value={value}>{children}</MainCtaContext.Provider>;
}
